import { render, staticRenderFns } from "./kvkksozlesme.vue?vue&type=template&id=1ab6a66a&"
import script from "./kvkksozlesme.vue?vue&type=script&lang=js&"
export * from "./kvkksozlesme.vue?vue&type=script&lang=js&"
import style0 from "./kvkksozlesme.vue?vue&type=style&index=0&id=1ab6a66a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports